import { Label } from '@/components/base/label'
import type { SwitchProps } from '@/components/base/switch'
import { Switch } from '@/components/base/switch'
import { DEBOUNCE_MEDIA_CONSTRAINTS_MS } from '@/helpers/constants'
import { useOptimisticUpdateWithPromise } from '@/hooks/useOptimisticUpdateWithPromise'
import { useRoomStoreActions } from '@/stores/room'
import { useCallback, useId } from 'react'

type SwitchNoiseSuppressionProps = Omit<
  SwitchProps,
  'checked' | 'id' | 'onCheckedChange'
> & {
  memberId: string
  noiseSuppression: boolean
}

export const SwitchNoiseSuppression = ({
  memberId,
  noiseSuppression,
  ...props
}: SwitchNoiseSuppressionProps) => {
  const { partialUpdateMicrophone } = useRoomStoreActions()

  const noiseSuppressionId = useId()

  const handleUpdateCallback = useCallback(
    (value: boolean) => {
      return partialUpdateMicrophone({
        constraints: { noiseSuppression: value },
        memberId,
      })
    },
    [memberId, partialUpdateMicrophone],
  )

  const { optimisticValue, handleUpdate } = useOptimisticUpdateWithPromise(
    noiseSuppression,
    handleUpdateCallback,
    DEBOUNCE_MEDIA_CONSTRAINTS_MS,
  )

  return (
    <>
      <Label htmlFor={noiseSuppressionId}>Noise Suppression</Label>
      <Switch
        id={noiseSuppressionId}
        checked={optimisticValue}
        onCheckedChange={handleUpdate}
        {...props}
      />
    </>
  )
}
